const faqData = [
  {
    id: 1,
    q: '51吃瓜黑料网是什么？',
    a: '51吃瓜黑料网是一个专注于娱乐八卦、明星动态、网红黑料等内容的聚合平台。我们每日从多渠道收集最新爆料，为用户提供一站式吃瓜体验。无论是娱乐圈内幕、综艺花絮还是网红争议，这里都有最全最新的资讯。',
  },
  {
    id: 2,
    q: '如何找到51吃瓜黑料入口一二三？',
    a: '本站就是51吃瓜黑料入口一二三的官方导航站。您可以将本页面加入浏览器收藏夹，或关注我们的社交账号获取最新地址通知。我们每日更新备用入口，确保您在网络波动时也能稳定访问所有吃瓜内容。',
  },
  {
    id: 3,
    q: '51吃瓜黑料网的内容多久更新一次？',
    a: '我们实行7x24小时滚动更新机制。编辑团队全天候监控各大社交平台、论坛和匿名爆料渠道，确保在事件发生后的最短时间内为您呈现最新内容。热门事件还会有持续追踪报道和深度分析。',
  },
  {
    id: 4,
    q: '如何向51吃瓜黑料投稿爆料？',
    a: '欢迎通过本页面的「爆料投稿」板块联系我们。您提供的每一条线索我们都会认真核实。对于重大独家爆料，我们会在发布时对投稿人信息严格保密。爆料一经采用，将获得首页展示机会。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            吃瓜指南
          </h2>
          <p className="mt-2 text-sm text-foreground-500">关于51吃瓜黑料，你想知道的都在这里</p>
        </div>

        <div className="max-w-3xl mx-auto grid gap-4">
          {faqData.map((item) => (
            <details
              key={item.id}
              className="group bg-background-50 border border-background-200/60 rounded-lg overflow-hidden cursor-pointer"
            >
              <summary className="flex items-center justify-between px-5 py-4 font-heading font-bold text-foreground-900 text-base list-none">
                <h3 className="text-base pr-4">{item.q}</h3>
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center text-foreground-400 group-open:hidden">
                  <i className="ri-add-line"></i>
                </span>
                <span className="flex-shrink-0 w-6 h-6 items-center justify-center text-primary-500 hidden group-open:flex">
                  <i className="ri-subtract-line"></i>
                </span>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}